import { render } from "./LazyIcon.vue?vue&type=template&id=deebb38a&scoped=true"
import script from "./LazyIcon.vue?vue&type=script&lang=js"
export * from "./LazyIcon.vue?vue&type=script&lang=js"

import "./LazyIcon.vue?vue&type=style&index=0&id=deebb38a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-deebb38a"]])

export default __exports__